module.exports = __webpack_public_path__ + "img/DA 1.e592de34.jpg";